import React, { useEffect, useState } from "react";

// Shown while a page chunk downloads. Short delay so fast loads never flash a spinner.
export const PageLoader = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShow(true), 150);
    return () => clearTimeout(t);
  }, []);
  return (
    <div
      data-testid="page-chunk-loading"
      role="status"
      aria-label="Loading"
      className="min-h-[60vh] flex items-center justify-center"
      style={{ background: "var(--bg-primary)" }}
    >
      {show && (
        <span
          className="h-8 w-8 rounded-full border-2 animate-spin"
          style={{ borderColor: "var(--border-color)", borderTopColor: "var(--accent-primary)" }}
        />
      )}
    </div>
  );
};
